import { render } from "./DataPlayerOnline.vue?vue&type=template&id=64b64422&scoped=true"
import script from "./DataPlayerOnline.vue?vue&type=script&lang=ts"
export * from "./DataPlayerOnline.vue?vue&type=script&lang=ts"

import "./DataPlayerOnline.vue?vue&type=style&index=0&id=64b64422&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64b64422"

export default script